import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {
  fetchTrustSnapTokenAction,
  selectTrustSnapToken,
  selectAccountId,
} from '../../../features/auth/ducks';

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      fetchTrustSnapToken: fetchTrustSnapTokenAction.request,
    },
    dispatch
  ),
});

const mapStateToProps = state => ({
  trustSnapToken: selectTrustSnapToken(state),
  accountId: selectAccountId(state),
});

@translate()
@connect(mapStateToProps, mapDispatchToProps)
export default class BiometricVerification extends Component {
  static propTypes = {
    accountId: PropTypes.string.isRequired,
    onClose: PropTypes.func.isRequired,
    saveVerificationResult: PropTypes.func.isRequired,
    actions: PropTypes.object.isRequired,
    trustSnapToken: PropTypes.string,
    t: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      verificationSuccess: false,
      verificationResult: null,
      localToken: props.trustSnapToken || null,
      starting: false,
    };
  }

  componentDidMount() {
    // one-time listener; it safely no-ops until iframe exists
    window.addEventListener(
      'message',
      (message) => {
        const frame = document.getElementById('trustSnapFrame')
        const { saveVerificationResult, onClose } = this.props;

        if (!frame) return;
        const childWindow = frame.contentWindow;
        if (message.source !== childWindow) return;

        const data = message.data;
        const success = data && data.type === 'SUCCESS';

        if (success) {
          const verificationId = this.state.localToken || this.props.trustSnapToken || '';
          saveVerificationResult({
            result: data.type,
            verificationId,
            data: data.data,
            message: 'id successfully verified',
          });
          this.setState({ verificationResult: data, verificationSuccess: true });
          onClose();
        }
      },
      false
    );
  }

  componentDidUpdate(prevProps) {
    // keď príde token z redux-u po kliknutí, prenesieme si ho do local state
    if (this.props.trustSnapToken && this.props.trustSnapToken !== prevProps.trustSnapToken) {
      this.setState({ localToken: this.props.trustSnapToken, starting: false });
    }
  }

  startBiometric = () => {
    const { actions, accountId } = this.props;
    this.setState({ starting: true });
    actions.fetchTrustSnapToken({ accountId });
  };

  closeIframe = () => {
    this.setState({ starting: false });
    this.props.onClose();
  };

  renderInitialButtons() {
    const { onClose, t } = this.props;
    const { starting } = this.state;

    return (
      <div
        id="iframe_modal"
        style={{
          width: '33%',
          minWidth: '500px',
          height: '33%',
          minHeight: '200px',
          border: '1px solid black',
          position: 'fixed',
          top: '50%',
          left: '50%',
          zIndex: 9999,
          transform: 'translate(-50%, -50%)',
          borderRadius: '10px',
          boxShadow: '0 0 10px 0 rgba(0, 0, 0, 0.2)',
          display: 'block',
          backgroundColor: 'white',
          padding: 20,
        }}
      >
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12, justifyContent:'center', height: '100%' }}>
          <button
            onClick={this.startBiometric}
            disabled={starting}
            style={{
              backgroundColor: '#1890ff',
              color: 'white',
              padding: '10px 14px',
              borderRadius: 6,
              border: 0,
              minHeight: 44,
              fontSize: 16,
              cursor: starting ? 'default' : 'pointer',
              width: 'fit-content',
              margin: '0 auto',
            }}
          >
            {starting
              ? t('Prebieha inicializácia…')
              : t('Kliknite sem na použitie biometrického overenia')}
          </button>

          {/* manuálne nahrávanie je dostupné iba PRED spustením procesu */}
          {!starting && (
            <button
              onClick={() => onClose()}
              style={{
                backgroundColor: '#f5222d',
                color: 'white',
                padding: '10px 14px',
                borderRadius: 6,
                border: 0,
                minHeight: 44,
                fontSize: 16,
                cursor: 'pointer',
                width: 'fit-content',
                margin: '0 auto',
              }}
            >
              {t('Chcem nahrať dokumenty manuálne')}
            </button>
          )}
        </div>
      </div>
    );
  }

  renderIframe() {
    const { t } = this.props;
    const token = this.state.localToken;
    if (!token) return null;

    return (     
      <Fragment>
        <div
          onClick={this.closeIframe}
          style={{
            position: 'fixed',
            inset: 0,
            zIndex: 9998,
            backgroundColor: 'rgba(0, 0, 0, 0.45)',
          }}
        />
        <div
          id="iframe_modal"
          style={{
            width: '80%',
            height: '80%',
            border: '0px',
            position: 'fixed', 
            top: '30%', 
            left: '50%', 
            zIndex: '9999', 
            transform: 'translate(-50%, -30%)', 
            borderRadius: '10px', 
            boxShadow: '0 0 10px 0 rgba(0, 0, 0, 0.2)', 
            display: 'block', 
            backgroundColor: 'white',
          }}
        > 
          <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', padding: 15}}> 
            <h2 style={{paddingBottom: 0}}></h2>
            <button 
              style={{ backgroundColor: 'red', color: 'white', padding: '5px 10px', borderRadius: '5px', border: '0px', minHeight: '40px', }}
              onClick={this.closeIframe}
            > 
              {t('Chcem nahrať dokumenty manuálne')}
            </button>
          </div> 
          <iframe 
            id='trustSnapFrame' //src={'https://google.com'} 
            src={`https://app.trustsnap.com/?verification=${token}`}
            allow="camera" 
            allowFullScreen 
            style={{ 
                width: '100%',
                height: '100%',
                border: '0px',
                borderRadius: '10px',
            }}            
          > 
          </iframe>
        </div>
      </Fragment>
    );
  }

  render() {
    // Render: ak nemáme localToken → úvodné dve tlačidlá; ak máme → iframe
    return this.state.localToken ? this.renderIframe() : this.renderInitialButtons();
  }
}



// WEBPACK FOOTER //
// ./src/features/documents/components/BiometricVerificationIFrame.js